export class TaskStatus {
  id: number;
  percentageState: number;
  listMonth: MonthInfo[] = [];
}

export class MonthInfo {
  id: number;
  month: string;
  percentageState: number;
}
